import React from "react";
import {Link} from "react-router-dom";
import {
    ActionIcon,
    Container,
    Divider,
    Group,
    Image,
    SimpleGrid,
    Stack,
    Text,
    useComputedColorScheme,
    useMantineTheme
} from "@mantine/core";
import {useConfig} from "../ConfigContext";

const Footer = () => {
    const theme = useMantineTheme();
    const {footerLinks, socialLinks, footerNote} = useConfig();
    const computedColorScheme = useComputedColorScheme('light');

    const isDark = computedColorScheme === "dark";
    const logo = isDark ? "/polyq_ai_logo_light.png" : "/polyq_ai_logo_dark.png";
    const linkColor = isDark ? theme.colors.gray[3] : theme.colors.gray[9];

    return (
        <Container size="xl" mt={80} pb="xl">
            <Divider mb="xl"/>
            <SimpleGrid cols={{base: 1, sm: 2, md: 4}} spacing="xl">
                <Stack gap="xs">
                    <Image src={logo} alt="PolyQ.ai" height={32} w="auto" fit="contain" style={{alignSelf: 'start'}}/>
                    <Text size="sm" c="dimmed">
                        An AI startup studio. We find problems where business knowledge gets trapped, and build the companies that solve them.
                    </Text>
                    <Group gap="xs" mt="xs">
                        {socialLinks.map((social) => (
                            <ActionIcon
                                key={social.label}
                                component="a"
                                href={social.href}
                                aria-label={social.label}
                                variant="subtle"
                                color="gray"
                            >
                                {React.createElement(social.icon, {size: 18, stroke: 1.5})}
                            </ActionIcon>
                        ))}
                    </Group>
                </Stack>

                {footerLinks.map((column) => (
                    <Stack key={column.title} gap="xs">
                        <Text fw={700} size="sm">{column.title}</Text>
                        {column.items.filter((item) => !item.disabled).map((item) => (
                            <Text
                                key={item.link}
                                component={Link}
                                to={item.link}
                                size="sm"
                                style={{color: linkColor, textDecoration: 'none'}}
                            >
                                {item.label}
                            </Text>
                        ))}
                    </Stack>
                ))}
            </SimpleGrid>

            <Divider my="xl"/>
            <Stack gap={4}>
                <Text size="sm" c="dimmed" ta="center">
                    ©2023-{new Date().getFullYear()} PolyQ.ai Inc. All rights reserved.
                </Text>
                <Text size="xs" c="dimmed" ta="center">
                    {footerNote}
                </Text>
            </Stack>
        </Container>
    );
};

export default Footer;
